import React from "react";
import { Link } from "react-router-dom";
const Footer = () => {
  return (
    <footer className="footer footer-four pt-4">
      {/* Footer Top */}
      <div className="footer-top aos" data-aos="fade-up">
        <div className="container">
          <div className="row">
            {/* Footer Contact */}
       <div className="col-lg-3">
  <div className="footer-contact footer-widget">
    <div className="footer-logo mb-3">
      <img src="/images/logo.jpg" className="img-fluid aos" alt="logo" />
    </div>

    <div className="footer-contact-info">
      <p className="text-white">
        We offer a diverse fleet of vehicles to suit every need, including compact cars, sedans, SUVs, and luxury vehicles.
      </p>

      {/* Phone */}
      <p className="d-flex align-items-center mb-2">
        <i className="fas fa-phone-alt me-2" style={{ color: "#CE8304" }}></i>
        <a href="tel:+919689815477" style={{ color: "#fff", textDecoration: "none" }}>+91 9689815477</a>
      </p>

      {/* Address */}
      <p className="d-fle align-items-start text-white">
        
        <h6><i className="fas fa-map-marker-alt me-2 mt-1 " style={{ color: "#CE8304" }}></i>Shivai Travels</h6>
      Shop no 1, Kamdhenu nagar, Guru mauli society, Vadgaon road, Near super bazar, Alandi, Pune 412105

      </p>
    </div>





<iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2711.572127679856!2d73.9067687!3d18.6878115!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bc2c9ad5f29512f%3A0x68cc8bf67473b0b6!2sShivai%20tours%20%26%20travels!5e1!3m2!1sen!2sin!4v1778688240010!5m2!1sen!2sin" width="100%" height="250"  allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>

    <li className="d-flex gap-3">
              <a href="https://www.instagram.com/shivai_travels_6357/" target="_blank" rel="noreferrer">
                <i className="fab fa-instagram text-white"></i>
              </a>

              <a href="https://www.facebook.com/profile.php?id=61590124316940" target="_blank" rel="noreferrer">
                <i className="fab fa-facebook-f text-white"></i>
              </a>

              <a href="https://x.com/Shivaitravels" target="_blank" rel="noreferrer">
                <i className="fab fa-twitter text-white"></i>
              </a>

               <a href="https://in.pinterest.com/shivaitravels/" target="_blank" rel="noreferrer">
                <i className="fab fa-pinterest-p text-white"></i>
              </a>
            </li>
  </div>
</div>

            {/* Footer Menus */}
            <div className="col-lg-9">
              <div className="row">
                <div className="col-lg-4 col-md-6">
                  <div className="footer-widget footer-menu">
                    <h5 className="footer-title">Our Services</h5>
                    <ul>
            
<li><Link to="/Pune-Outstation-Cab-Service"><i className="fa fa-car darkcolor"></i> Pune Outstation Cab Service</Link></li>
<li><Link to="/Pune-Taxi-Service"><i className="fa fa-car darkcolor"></i> Pune Taxi Service</Link></li>
<li><Link to="/Pune-Cab-Booking"><i className="fa fa-car darkcolor"></i> Pune Cab Booking</Link></li>
<li><Link to="/Best-Cab-Service-in-Pune"><i className="fa fa-car darkcolor"></i> Best Cab Service in Pune</Link></li>
<li><Link to="/Outstation-Taxi-Service-Pune"><i className="fa fa-car darkcolor"></i> Outstation Taxi Service Pune</Link></li>
<li><Link to="/Cheap-Cabs-in-Pune"><i className="fa fa-car darkcolor"></i> Cheap Cabs in Pune</Link></li>
<li><Link to="/Pune-Cab-Fare"><i className="fa fa-car darkcolor"></i> Pune Cab Fare</Link></li>
<li><Link to="/Corporate-Cab-Service-Pune"><i className="fa fa-car darkcolor"></i> Corporate Cab Service Pune</Link></li>
<li><Link to="/Pune-Airport-Cab"><i className="fa fa-car darkcolor"></i> Pune Airport Cab</Link></li>
<li><Link to="/Pune-Railway-Station-Cab-Service"><i className="fa fa-car darkcolor"></i> Pune Railway Station Cab Service</Link></li>
<li><Link to="/Pune-One-Way-Cab-Service"><i className="fa fa-car darkcolor"></i> Pune One Way Cab Service</Link></li>
<li><Link to="/Pune-Local-and-Outstation-Cab"><i className="fa fa-car darkcolor"></i> Pune Local and Outstation Cab</Link></li>
<li><Link to="/Pune-to-Mumbai-Cab"><i className="fa fa-car darkcolor"></i> Pune to Mumbai Cab</Link></li>
<li><Link to="/Pune-to-Mumbai-Airport-Cab"><i className="fa fa-car darkcolor"></i> Pune to Mumbai Airport Cab</Link></li>
<li><Link to="/Pune-to-Nashik-Cab-Service"><i className="fa fa-car darkcolor"></i> Pune to Nashik Cab Service</Link></li>
<li><Link to="/Pune-to-Nagpur-Cab"><i className="fa fa-car darkcolor"></i> Pune to Nagpur Cab</Link></li>
<li><Link to="/Pune-to-Kolhapur-Cab"><i className="fa fa-car darkcolor"></i> Pune to Kolhapur Cab</Link></li>
<li><Link to="/Pune-to-Solapur-Cab-Service" className="d-none"><i className="fa fa-car darkcolor"></i> Pune to Solapur Cab Service</Link></li>
<li><Link to="/Pune-to-Ahmednagar-Taxi" className="d-none"><i className="fa fa-car darkcolor"></i> Pune to Ahmednagar Taxi</Link></li>
<li><Link to="/Pune-to-Satara-Cab-Service" className="d-none"><i className="fa fa-car darkcolor"></i> Pune to Satara Cab Service</Link></li>
<li><Link to="/Pune-to-Jalgaon-Cab-Service" className="d-none"><i className="fa fa-car darkcolor"></i> Pune to Jalgaon Cab Service</Link></li>
{/* <li><Link to="/Pune-to-Dhule-Cab-Service"><i className="fa fa-car darkcolor"></i> Pune to Dhule Cab Service</Link></li> */}
<li><Link to="/Pune-to-Thane-Cab" className="d-none"><i className="fa fa-car darkcolor"></i> Pune to Thane Cab</Link></li>
<li>
  <Link to="/Pune-to-Panvel-Cab" className="d-none">
    <i className="fa fa-car darkcolor"></i> Pune to Panvel Cab
  </Link>
</li>

<li>
  <Link to="/Pune-to-Hyderabad-Cab" className="d-none">
    <i className="fa fa-car darkcolor"></i> Pune to Hyderabad Cab
  </Link>
</li>

<li>
  <Link to="/Pune-to-Goa-Cab-Service" className="d-none">
    <i className="fa fa-car darkcolor"></i> Pune to Goa Cab Service
  </Link>
</li>

<li>
  <Link to="/Pune-to-Sambhaji-Nagar-Cab" className="d-none">
    <i className="fa fa-car darkcolor"></i> Pune to Sambhaji Nagar Cab (Aurangabad)
  </Link>
</li>

<li>
  <Link to="/Pune-to-Nanded-Cab-Service" className="d-none">
    <i className="fa fa-car darkcolor"></i> Pune to Nanded Cab Service
  </Link>
</li>

<li>
  <Link to="/Pune-to-Indore-Cab" className="d-none">
    <i className="fa fa-car darkcolor"></i> Pune to Indore Cab
  </Link>
</li>

<li>
  <Link to="/Pune-to-Surat-Cab" className="d-none">
    <i className="fa fa-car darkcolor"></i> Pune to Surat Cab
  </Link>
</li>

{/* <li><Link to="/Pune-to-Latur-Cab-Service"><i className="fa fa-car darkcolor"></i> Pune to Latur Cab Service</Link></li> */}

{/* <li><Link to="/Pune-to-Vapi-Cab-Service"><i className="fa fa-car darkcolor"></i> Pune to Vapi Cab Service</Link></li> */}

<li>
  <Link to="/Pune-to-Ujjain-Cab-Service" className="d-none">
    <i className="fa fa-car darkcolor"></i> Pune to Ujjain Cab Service
  </Link>
</li>

{/* <li><Link to="/Pune-to-Kalyan-Cab"><i className="fa fa-car darkcolor"></i> Pune to Kalyan Cab</Link></li> */}

{/* <li><Link to="/Pune-to-Dombivli-Cab"><i className="fa fa-car darkcolor"></i> Pune to Dombivli Cab</Link></li> */}

<li>
  <Link to="/Pune-to-Lonavala-Cab" className="d-none">
    <i className="fa fa-car darkcolor"></i> Pune to Lonavala Cab
  </Link>
</li>

<li>
  <Link to="/Pune-to-Matheran-Taxi-Service" className="d-none">
    <i className="fa fa-car darkcolor"></i> Pune to Matheran Taxi Service
  </Link>
</li>

<li>
  <Link to="/Pune-to-Mahabaleshwar-Taxi" className="d-none">
    <i className="fa fa-car darkcolor"></i> Pune to Mahabaleshwar Taxi
  </Link>
</li>

<li>
  <Link to="/Pune-to-Bangalore-Cab" className="d-none">
    <i className="fa fa-car darkcolor"></i> Pune to Bangalore Cab
  </Link>
</li>

<li>
  <Link to="/Pune-to-Ayodhya-Tour-Package" className="d-none">
    <i className="fa fa-car darkcolor"></i> Pune to Ayodhya Tour Package
  </Link>
</li>

{/* <li><Link to="/Pune-to-Khandala-Cab"><i className="fa fa-car darkcolor"></i> Pune to Khandala Cab</Link></li> */}

{/* <li><Link to="/Pune-to-Panchgani-Cab-Service"><i className="fa fa-car darkcolor"></i> Pune to Panchgani Cab Service</Link></li> */}

{/* <li><Link to="/Pune-to-Lavasa-Cab-Service"><i className="fa fa-car darkcolor"></i> Pune to Lavasa Cab Service</Link></li> */}

<li>
  <Link to="/Pune-to-Igatpuri-Taxi" className="d-none">
    <i className="fa fa-car darkcolor"></i> Pune to Igatpuri Taxi
  </Link>
</li>

<li>
  <Link to="/Pune-to-Bhandardara-Cab" className="d-none">
    <i className="fa fa-car darkcolor"></i> Pune to Bhandardara Cab
  </Link>
</li>

<li>
  <Link to="/Pune-to-Karjat-Cab" className="d-none">
    <i className="fa fa-car darkcolor"></i> Pune to Karjat Cab
  </Link>
</li>

<li>
  <Link to="/Pune-to-Amboli-Ghat-Taxi" className="d-none">
    <i className="fa fa-car darkcolor"></i> Pune to Amboli Ghat Taxi
  </Link>
</li>                    </ul>
                  </div>
                </div>
                <div className="col-lg-4 col-md-6">
                  <div className="footer-widget footer-menu">
                    <h5 className="footer-title">Our Services</h5>
  <ul>
<li><Link to="/Pune-to-Chikhaldara-Cab"><i className="fa fa-car darkcolor"></i> Pune to Chikhaldara Cab</Link></li>
<li><Link to="/Pune-to-Tamhini-Ghat-Cab"><i className="fa fa-car darkcolor"></i> Pune to Tamhini Ghat Cab</Link></li>
<li><Link to="/Pune-to-Shirdi-Cab"><i className="fa fa-car darkcolor"></i> Pune to Shirdi Cab</Link></li>
<li><Link to="/Pune-to-Trimbakeshwar-Cab-Service"><i className="fa fa-car darkcolor"></i> Pune to Trimbakeshwar Cab Service</Link></li>
<li><Link to="/Pune-to-Bhimashankar-Taxi-Service"><i className="fa fa-car darkcolor"></i> Pune to Bhimashankar Taxi Service</Link></li>
<li><Link to="/Pune-to-Ashtavinayak-Darshan-Cab"><i className="fa fa-car darkcolor"></i> Pune to Ashtavinayak Darshan Cab</Link></li>
<li><Link to="/Pune-to-Jejuri-Cab-Service"><i className="fa fa-car darkcolor"></i> Pune to Jejuri Cab Service</Link></li>
<li><Link to="/Pune-to-Pandharpur-Taxi"><i className="fa fa-car darkcolor"></i> Pune to Pandharpur Taxi</Link></li>
<li><Link to="/Pune-to-Tuljapur-Cab"><i className="fa fa-car darkcolor"></i> Pune to Tuljapur Cab</Link></li>
<li><Link to="/Pune-to-Akkalkot-Cab-Service"><i className="fa fa-car darkcolor"></i> Pune to Akkalkot Cab Service</Link></li>
<li><Link to="/Pune-to-Shani-Shingnapur-Cab"><i className="fa fa-car darkcolor"></i> Pune to Shani Shingnapur Cab</Link></li>
<li><Link to="/Pune-to-Shegaon-Cab"><i className="fa fa-car darkcolor"></i> Pune to Shegaon Cab</Link></li>
<li><Link to="/Pune-to-Ganpatipule-Taxi"><i className="fa fa-car darkcolor"></i> Pune to Ganpatipule Taxi</Link></li>
<li><Link to="/Pune-to-Konkan-Darshan-Cab"><i className="fa fa-car darkcolor"></i> Pune to Konkan Darshan Cab</Link></li>
<li><Link to="/Pune-to-Alibag-Cab"><i className="fa fa-car darkcolor"></i> Pune to Alibag Cab</Link></li>
<li><Link to="/Pune-to-Ratnagiri-Taxi-Service"><i className="fa fa-car darkcolor"></i> Pune to Ratnagiri Taxi Service</Link></li>
<li><Link to="/Pune-to-Tarkarli-Cab"><i className="fa fa-car darkcolor"></i> Pune to Tarkarli Cab</Link></li>
<li><Link to="/Pune-to-Sindhudurg-Cab-Service" className="d-none"><i className="fa fa-car darkcolor"></i> Pune to Sindhudurg Cab Service</Link></li>
<li><Link to="/Pune-to-Harihareshwar-Taxi" className="d-none"><i className="fa fa-car darkcolor"></i> Pune to Harihareshwar Taxi</Link></li>
<li><Link to="/Pune-to-Diveagar-Cab" className="d-none"><i className="fa fa-car darkcolor"></i> Pune to Diveagar Cab</Link></li>
<li><Link to="/Pune-to-Dapoli-Cab" className="d-none"><i className="fa fa-car darkcolor"></i> Pune to Dapoli Cab</Link></li>
<li><Link to="/Pune-to-Guhagar-Taxi" className="d-none" ><i className="fa fa-car darkcolor"></i> Pune to Guhagar Taxi</Link></li>
<li>
  <Link to="/Pune-to-Velas-Beach-Cab" className="d-none">
    <i className="fa fa-car darkcolor"></i> Pune to Velas Beach Cab
  </Link>
</li>

<li>
  <Link to="/Pune-to-Malvan-Cab-Service" className="d-none">
    <i className="fa fa-car darkcolor"></i> Pune to Malvan Cab Service
  </Link>
</li>

<li>
  <Link to="/Pune-Darshan-Cab-Service" className="d-none">
    <i className="fa fa-car darkcolor"></i> Pune Darshan Cab Service
  </Link>
</li>

<li>
  <Link to="/Pune-City-Tour-Taxi" className="d-none">
    <i className="fa fa-car darkcolor"></i> Pune City Tour Taxi
  </Link>
</li>

<li>
  <Link to="/Pune-One-Day-Tour-Cab" className="d-none">
    <i className="fa fa-car darkcolor"></i> Pune One Day Tour Cab
  </Link>
</li>

<li>
  <Link to="/Pune-Weekend-Tour-Packages" className="d-none">
    <i className="fa fa-car darkcolor"></i> Pune Weekend Tour Packages
  </Link>
</li>

<li>
  <Link to="/Pune-to-Fort-Tour-Cab" className="d-none">
    <i className="fa fa-car darkcolor"></i> Pune to Fort Tour Cab (Sinhagad Rajgad Torna Lohagad)
  </Link>
</li>

<li>
  <Link to="/Pune-Heritage-Tour-Cab" className="d-none">
    <i className="fa fa-car darkcolor"></i> Pune Heritage Tour Cab
  </Link>
</li>

<li>
  <Link to="/Ashtavinayak-Darshan-Cab-from-Pune" className="d-none">
    <i className="fa fa-car darkcolor"></i> Ashtavinayak Darshan Cab from Pune
  </Link>
</li>

<li>
  <Link to="/Pune-Temple-Tour-Cab" className="d-none">
    <i className="fa fa-car darkcolor"></i> Pune Temple Tour Cab
  </Link>
</li>

<li>
  <Link to="/Pune-Pilgrimage-Taxi-Service" className="d-none">
    <i className="fa fa-car darkcolor"></i> Pune Pilgrimage Taxi Service
  </Link>
</li>

<li>
  <Link to="/Pune-Religious-Tour-Package-Cab" className="d-none">
    <i className="fa fa-car darkcolor"></i> Pune Religious Tour Package Cab
  </Link>
</li>

<li>
  <Link to="/Pune-Airport-Cab-Service" className="d-none">
    <i className="fa fa-car darkcolor"></i> Pune Airport Cab Service
  </Link>
</li>

<li>
  <Link to="/Pune-to-Shirdi-Airport-Cab" className="d-none">
    <i className="fa fa-car darkcolor"></i> Pune to Shirdi Airport Cab
  </Link>
</li>

<li>
  <Link to="/Pune-One-Way-Taxi-Service" className="d-none">
    <i className="fa fa-car darkcolor"></i> Pune One Way Taxi Service
  </Link>
</li>

<li>
  <Link to="/Pune-Round-Trip-Cab-Service" className="d-none">
    <i className="fa fa-car darkcolor"></i> Pune Round Trip Cab Service
  </Link>
</li>
                    </ul>
                  </div>
                </div>
                <div className="col-lg-4 col-md-6">
                  <div className="footer-widget footer-menu">
                    <h5 className="footer-title">Our Services</h5>
                    <ul>
<li><Link to="/Pune-to-Parbhani-Cab-Service"><i className="fa fa-car darkcolor"></i> Pune to Parbhani Cab Service</Link></li>

<li><Link to="/Pune-to-Aurangabad-Cab-Service"><i className="fa fa-car darkcolor"></i> Pune to Aurangabad Cab Service</Link></li>
<li><Link to="/Pune-to-Shaniwar-Wada-Tour-Cab"><i className="fa fa-car darkcolor"></i> Pune to Shaniwar Wada Tour Cab</Link></li>
<li><Link to="/Pune-to-Bijapur-Cab-Service"><i className="fa fa-car darkcolor"></i> Pune to Bijapur Cab Service</Link></li>
<li><Link to="/Pune-to-Belgaum-Cab-Service"><i className="fa fa-car darkcolor"></i> Pune to Belgaum Cab Service</Link></li>
<li><Link to="/Pune-to-Chiplun-Taxi"><i className="fa fa-car darkcolor"></i> Pune to Chiplun Taxi</Link></li>
<li><Link to="/Pune-to-Mahad-Cab-Service"><i className="fa fa-car darkcolor"></i> Pune to Mahad Cab Service</Link></li>
<li><Link to="/Pune-to-Mangaon-Cab"><i className="fa fa-car darkcolor"></i> Pune to Mangaon Cab</Link></li>
<li><Link to="/Pune-to-Pen-Cab-Service"><i className="fa fa-car darkcolor"></i> Pune to Pen Cab Service</Link></li>
<li><Link to="/Pune-to-Roha-Taxi-Service"><i className="fa fa-car darkcolor"></i> Pune to Roha Taxi Service</Link></li>
<li><Link to="/Pune-to-Kashid-Beach-Cab"><i className="fa fa-car darkcolor"></i> Pune to Kashid Beach Cab</Link></li>
<li><Link to="/Pune-to-Murud-Janjira-Cab"><i className="fa fa-car darkcolor"></i> Pune to Murud Janjira Cab</Link></li>
<li><Link to="/Pune-to-Shrivardhan-Taxi-Service"><i className="fa fa-car darkcolor"></i> Pune to Shrivardhan Taxi Service</Link></li>
<li><Link to="/Pune-to-Wai-Cab-Service"><i className="fa fa-car darkcolor"></i> Pune to Wai Cab Service</Link></li>
<li><Link to="/Pune-to-Aundha-Nagnath-Cab"><i className="fa fa-car darkcolor"></i> Pune to Aundha Nagnath Cab</Link></li>
<li><Link to="/Tempo-Traveller-on-rent-in-pune"><i className="fa fa-car darkcolor"></i> Tempo Traveller on rent in pune</Link></li>
<li><Link to="/Innova-crysta-On-rent-in-pune"><i className="fa fa-car darkcolor"></i> Innova crysta On rent in pune</Link></li>
<li><Link to="/Swift-Dzire-on-rent-in-pune" className="d-none"><i className="fa fa-car darkcolor"></i> Swift Dzire on rent in pune</Link></li>
<li><Link to="/Ertiga-on-rent-in-pune" className="d-none"><i className="fa fa-car darkcolor"></i> Ertiga on rent in pune</Link></li>
<li><Link to="/7-Seater-on-rent-in-Pune" className="d-none"><i className="fa fa-car darkcolor"></i> 7 Seater on rent in Pune</Link></li>
<li><Link to="/Innova-on-rent-in-Pune" className="d-none"><i className="fa fa-car darkcolor"></i> Innova on rent in Pune</Link></li>
<li><Link to="/13-Seater-on-rent-in-Pune" className="d-none"><i className="fa fa-car darkcolor"></i> 13 Seater on rent in Pune</Link></li>


<li>
  <Link to="/Urbania-On-Rent-in-Pune" className="d-none">
    <i className="fa fa-car darkcolor"></i> Urbania On Rent in Pune
  </Link>
</li>

<li>
  <Link to="/17-Seater-Urbania-on-Rent-in-Pune" className="d-none">
    <i className="fa fa-car darkcolor"></i> 17 Seater Urbania on Rent in Pune
  </Link>
</li>

<li>
  <Link to="/Urbania-Hire-for-Picnic-in-Pune" className="d-none">
    <i className="fa fa-car darkcolor"></i> Urbania Hire for Picnic in Pune
  </Link>
</li>

<li>
  <Link to="/Urbania-On-Rent-for-Outstation-Pune" className="d-none">
    <i className="fa fa-car darkcolor"></i> Urbania On Rent for Outstation Pune
  </Link>
</li>

<li>
  <Link to="/Pune-to-Mumbai-Urbania-On-Rent" className="d-none">
    <i className="fa fa-car darkcolor"></i> Pune to Mumbai Urbania On Rent
  </Link>
</li>

<li>
  <Link to="/Luxury-Force-Urbania-on-Rent-in-Pune" className="d-none">
    <i className="fa fa-car darkcolor"></i> Luxury Force Urbania on Rent in Pune
  </Link>
</li>

<li>
  <Link to="/Urbania-Hire-in-Pune" className="d-none">
    <i className="fa fa-car darkcolor"></i> Urbania Hire in Pune
  </Link>
</li>

<li>
  <Link to="/13-Seater-Urbania-on-Rent-in-Pune" className="d-none">
    <i className="fa fa-car darkcolor"></i> 13 Seater Urbania on Rent in Pune
  </Link>
</li>

<li>
  <Link to="/AC-Urbania-on-Rent-in-Pune" className="d-none">
    <i className="fa fa-car darkcolor"></i> AC Urbania on Rent in Pune
  </Link>
</li>

<li>
  <Link to="/Urbania-per-km-rate-in-Pune" className="d-none">
    <i className="fa fa-car darkcolor"></i> Urbania per km rate in Pune
  </Link>
</li>

<li>
  <Link to="/Tempo-Traveller-on-Rent-in-Pune" className="d-none">
    <i className="fa fa-car darkcolor"></i> Tempo Traveller on Rent in Pune
  </Link>
</li>

<li>
  <Link to="/Luxury-Tempo-Traveller-On-Rent-in-Pune" className="d-none">
    <i className="fa fa-car darkcolor"></i> Luxury Tempo Traveller On Rent in Pune
  </Link>
</li>

<li>
  <Link to="/13-Tempo-Traveller-On-Rent-in-Pune" className="d-none">
    <i className="fa fa-car darkcolor"></i> 13 Tempo Traveller On Rent in Pune
  </Link>
</li>

<li>
  <Link to="/17-Seater-Tempo-Traveller-on-rent-in-Pune" className="d-none">
    <i className="fa fa-car darkcolor"></i> 17 Seater Tempo Traveller on rent in Pune
  </Link>
</li>

<li>
  <Link to="/Pune-to-Mahabaleshwar-Tempo-Traveller-on-Rent" className="d-none">
    <i className="fa fa-car darkcolor"></i> Pune to Mahabaleshwar Tempo Traveller on Rent
  </Link>
</li>                </ul>
                
                
                
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Footer Bottom */}
      <div className="footer-bottom">
        <div className="container">
          <div className="copyright">
            <div className="row align-items-center row-gap-3 text-center">
              <div className="col-12">
                  <p className="copyright-text text-white">
              All Rights Reserved &copy;  <span className="darkcolorrr">Shivai Travels</span> <span id="date">{new Date().getFullYear()}</span>{' '}
                <span href="#"> Developed By </span> <a href="https://www.dexterintelligence.com/" className='d-inline' target="_blank" rel="noopener noreferrer">
                <span className="darkcolorrr">&nbsp;Dexter Intelligence</span>
              </a> | Hosted By <a href="https://www.urvahosting.com/" className='d-inline ' target="_blank" rel="noopener noreferrer">
                <span className="darkcolorrr">&nbsp;Urva Hosting</span>
              </a>
              </p>
              </div>
              {/* <div className="col-lg-4">
                <div className="payment-list">
                  <a href="javascript:void(0);">
                    <img src="/img/icons/payment-01.svg" alt="img" />
                  </a>
                  <a href="javascript:void(0);">
                    <img src="/img/icons/payment-02.svg" alt="img" />
                  </a>
                  <a href="javascript:void(0);">
                    <img src="/img/icons/payment-03.svg" alt="img" />
                  </a>
                </div>
              </div> */}
              {/* <div className="col-lg-4">
                <ul className="privacy-link">
                  <li><a href="privacy-policy.html">Privacy</a></li>
                  <li><a href="terms-condition.html">Terms & Condition</a></li>
                  <li><a href="javascript:void(0);">Refund Policy</a></li>
                </ul>
              </div> */}
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;


